var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1577705300"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1655",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1577705299"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3467667",
    x: 19.5,
    y: 13,
    width: 4,
    height: 17,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3467668",
    x: 13,
    y: 23.5,
    width: 4,
    height: 17,
    transform: "rotate(-90 13 23.5)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusFill);
export default __webpack_public_path__ + "static/media/plus-fill.ba8dadf1af04868f1701fe53f0b4d9c0.svg";
export { ForwardRef as ReactComponent };